import { render, staticRenderFns } from "./TournamentFormatSelector.vue?vue&type=template&id=20aeca91"
import script from "./TournamentFormatSelector.vue?vue&type=script&lang=js"
export * from "./TournamentFormatSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports